import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "components/Loader";
import TimelineService from "services/TimelineService";
import * as timelineActions from "reteamStore/actions";
import Scrollbar from "react-scrollbars-custom";

export default ({ selectTitle, selectedTitleId }) => {
  const dispatch = useDispatch();
  const { messageTemplates } = useSelector((state) => state.timelineReducer);
  const [loading, setLoading] = useState(false);
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
    height: "100%",
    alignItems: "center",
  };

  useEffect(() => {
    // if (messageTemplates?.length !== 0) {
    //   return;
    // } 

    (async () => {
      setLoading(true);
      await getTimeLineMessageTemplates();
      setLoading(false);
    })();

    //eslint-disable-next-line
  }, []);

  const getTimeLineMessageTemplates = async () => {
    try {
      const response = await TimelineService.getTimeLineMessageTemplates();
      dispatch(timelineActions.getTimeLineMessageTemplates(response.data.data));
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message);
      }
    }
  };

  return (
    <div className="messageContent">
      {loading && (
        <div style={loaderStyle}>
          <Loader width={40} height={40} />
        </div>
      )}
      <Scrollbar
        style={{
          height: "260px",
          border: "1px solid #43434317",
          borderLeft: "none",
        }}
      >
        <ul className="messageList">
          {!loading &&
            messageTemplates?.length > 0 &&
            messageTemplates.map((message) => (
              <li
                className={
                  selectedTitleId === message.id ? "selected-title" : ""
                }
                key={message.id}
                onClick={() => selectTitle(message.id, message.title)}
              >
                {message.title}
              </li>
            ))}
        </ul>
      </Scrollbar>
    </div>
  );
};
